"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxToggler = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const CheckboxToggler = ({
  toggleVoucher,
  isChecked
}) => {
  const handleClick = (0, _react.useCallback)(() => {
    toggleVoucher();
  }, [toggleVoucher]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Switch, {
    checked: isChecked,
    onChange: handleClick
  });
};
exports.CheckboxToggler = CheckboxToggler;